import React, { useContext } from "react";
import { Header as BaseHeader } from "../../../common/components/Header";
import { LandingContext } from "../../context/landing";
import { useHeroVariant } from "./variants/useHeroVariant";

export const Header: React.FC = () => {
  const { Layout, Variant } = useHeroVariant();
  const context = useContext(LandingContext);
  const { offersMode, formOpen } = context;
  return (
    <BaseHeader withResume={offersMode}>
      <Layout formOpen={formOpen} offersMode={offersMode}>
        <Variant {...context} />
      </Layout>
    </BaseHeader>
  );
};
